module.exports = __webpack_public_path__ + "img/iIcon_artikel-entfernen.60b4fc88.svg";